import { createRoot } from 'react-dom/client';
import App from './app-applicant';

createRoot(document.getElementById('root')).render(<App />);
